import { Popover, styled } from "@mui/material";
import { tokens } from "@/tokens";

const DialogMenu = styled(Popover)(() => ({
  "& .MuiBackdrop-root": {
    background: tokens.text.primary,
    opacity: "0.3 !important",
  },
  "& .MuiPaper-root": {
    width: 400,
    marginTop: 12,
    marginLeft: 8,
    border: `1px solid ${tokens.border.default}`,
    borderRadius: 12,
    boxShadow: "0px 10px 10px 0 #100A551A",
  },
  "& .MuiList-root": {
    padding: "0",
  },
}));

export default DialogMenu;
